import { createContext } from 'react';

export interface AuthContextType {
  markAsLoggedIn: () => void;
  logout: (manual?: boolean) => Promise<void>;
  skipAuthRedirect: boolean;
  clearSkipAuthRedirect: () => void;
  getLoggedInStatus: () => Promise<boolean>;
  isLoggedIn: boolean | null;
}

export const AuthContext = createContext<AuthContextType | null>(null);
